import { Controller } from "@hotwired/stimulus"

// Store product gallery (TMS-996): thumbnails swap the main image. Images keep staff order,
// primary first; a product with one image renders no thumbnails at all.
export default class extends Controller {
  static targets = ["thumb", "image"]

  show(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.imageTargets.forEach((image, i) => { image.hidden = i !== index })
    this.thumbTargets.forEach((thumb, i) => {
      thumb.classList.toggle("is-active", i === index)
      thumb.setAttribute("aria-pressed", i === index)
    })
  }
}
